var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonFlagScotland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str2 {stroke:black;stroke-width:5.9035}\n    .str1 {stroke:black;stroke-width:0.899693}\n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil2 {fill:none}\n    .fil1 {fill:#1B1BF7}\n    .fil0 {fill:white}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "_619567376"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str1",
    d: "M286 569l-95 -138 -96 138 -30 0 0 -45 95 -138 -95 -140 0 -45 30 0 96 139 95 -139 30 0 0 45 -95 140 95 138 0 45 -30 0zm41 -375l0 383 -273 0 0 -383 273 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2 str2",
    transform: "matrix(3.2504E-14 1 -1.22728 2.64845E-14 326.596 193.538)",
    width: 383,
    height: 222
  })), /*#__PURE__*/React.createElement("g", {
    id: "_619567256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str1",
    d: "M286 1120l-95 -138 -96 138 -30 0 0 -45 95 -138 -95 -140 0 -45 30 0 96 139 95 -139 30 0 0 45 -95 140 95 138 0 45 -30 0zm41 -375l0 383 -273 0 0 -383 273 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2 str2",
    transform: "matrix(3.2504E-14 1 -1.22728 2.64845E-14 326.596 744.591)",
    width: 383,
    height: 222
  })), /*#__PURE__*/React.createElement("g", {
    id: "_619566224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str1",
    d: "M286 1653l-95 -138 -96 138 -30 0 0 -45 95 -138 -95 -140 0 -45 30 0 96 139 95 -139 30 0 0 45 -95 140 95 138 0 45 -30 0zm41 -375l0 383 -273 0 0 -383 273 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2 str2",
    transform: "matrix(3.2504E-14 1 -1.22728 2.64845E-14 326.596 1277.74)",
    width: 383,
    height: 222
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonFlagScotland);
export default __webpack_public_path__ + "static/media/ribbon-flag-scotland.7f034553ad521242496fac19a2970ed2.svg";
export { ForwardRef as ReactComponent };